import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { CreateRestaurant } from './pages/CreateRestaurant';
import { RestaurantDetail } from './pages/RestaurantDetail';
import { MenuManagement } from './pages/MenuManagement';
import { QRMenu } from './pages/QRMenu';
import { QRCategory } from './pages/QRCategory';
import { QRItem } from './pages/QRItem';
import { Landing } from './pages/Landing';
import { LandingAdmin } from './pages/LandingAdmin';
import MailPanel from './pages/MailPanel';
import { KitchenDisplay } from './pages/KitchenDisplay';
import { WaiterPanel } from './pages/WaiterPanel';
import { TablesManagement, TablesPrint } from './pages/TablesManagement';
import TableNfcCodes from './pages/TableNfcCodes';
import { RestaurantSecurity } from './pages/RestaurantSecurity';
import { OwnerAnalytics } from './pages/OwnerAnalytics';
import { QRRouteWrapper } from './components/QRRouteWrapper';
import { SlugResolver } from './components/SlugResolver';
import { CustomScriptsInjector } from './components/CustomScriptsInjector';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <CustomScriptsInjector />
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/qr-menu/:restaurantId" element={<QRRouteWrapper><QRMenu /></QRRouteWrapper>} />
            <Route path="/qr-menu/:restaurantId/t/:tableNumber" element={<QRRouteWrapper><QRMenu /></QRRouteWrapper>} />
            <Route path="/qr-menu/:restaurantId/category/:categoryId" element={<QRRouteWrapper><QRCategory /></QRRouteWrapper>} />
            <Route path="/qr-menu/:restaurantId/t/:tableNumber/category/:categoryId" element={<QRRouteWrapper><QRCategory /></QRRouteWrapper>} />
            <Route path="/qr-menu/:restaurantId/item/:itemId" element={<QRRouteWrapper><QRItem /></QRRouteWrapper>} />
            <Route path="/qr-menu/:restaurantId/t/:tableNumber/item/:itemId" element={<QRRouteWrapper><QRItem /></QRRouteWrapper>} />

            {/* Protected routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/restaurant/create"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'restaurant_owner']}>
                  <CreateRestaurant />
                </ProtectedRoute>
              }
            />
            <Route
              path="/restaurant/:restaurantId"
              element={
                <ProtectedRoute>
                  <RestaurantDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu/manage/:restaurantId"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'restaurant_owner']}>
                  <MenuManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/landing"
              element={
                <ProtectedRoute allowedRoles={['super_admin']}>
                  <LandingAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/mail"
              element={
                <ProtectedRoute allowedRoles={['super_admin']}>
                  <MailPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kitchen/:restaurantId"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'restaurant_owner']}>
                  <KitchenDisplay />
                </ProtectedRoute>
              }
            />
            <Route
              path="/waiter/:restaurantId"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'restaurant_owner']}>
                  <WaiterPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/restaurant/:restaurantId/tables"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'restaurant_owner']}>
                  <TablesManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/restaurant/:restaurantId/tables/print"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'restaurant_owner']}>
                  <TablesPrint />
                </ProtectedRoute>
              }
            />
            <Route
              path="/restaurant/:restaurantId/nfc"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'restaurant_owner']}>
                  <TableNfcCodes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/restaurant/:restaurantId/security"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'restaurant_owner']}>
                  <RestaurantSecurity />
                </ProtectedRoute>
              }
            />
            <Route
              path="/restaurant/:restaurantId/analytics"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'restaurant_owner']}>
                  <OwnerAnalytics />
                </ProtectedRoute>
              }
            />

            <Route path="/" element={<Landing />} />
            {/* Pretty slug URL — SlugResolver handles all sub-paths:
                /baton-cafe, /baton-cafe/masa3, /baton-cafe/category/:id,
                /baton-cafe/item/:id, /baton-cafe/masa3/category/:id, /baton-cafe/cart, etc. */}
            <Route path="/:slug/*" element={<SlugResolver />} />
            <Route path="/:slug" element={<SlugResolver />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
